import React, { Component, Fragment } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push, goBack } from 'react-router-redux';
import {
  getPoliciesForVertical,
  showMenu,
  hideMenu,
  hideToast,
} from '../../store/actions';
import seo from 'shared/lib/seo';
import compact from 'lodash/compact';
import filter from 'lodash/filter';
import omit from 'lodash/omit';
import without from 'lodash/without';
import Footer from '../../components/Footer';
import Toast from '../../components/Toast';
import TrustSymbols from '../../components/TrustSymbols';
import TopNavBar from '../../components/TopNavBar';
import VERTICALS from 'shared/lib/constants/verticals';
import * as collectiblesApi from '../../api/collectibles';
import * as sharedApi from 'shared/lib/api';
import withSubapp from 'shared/lib/apps/CollectiblesApp/hoc';
import withGlobals from '../../withGlobals';
import NotificationBar from 'shared/lib/components/NotificationBar';
import './CollectiblesContainer.css';

const verticalName = 'collectibles';

const protectionList = [
  'Property theft',
  'Damages beyond wear-and-tear',
  'Unintentional loss of an item',
];

class CollectiblesContainer extends Component {
  state = {
    isPolicyFlow: false,
  };

  componentDidMount() {
    seo.setProps({
      title: 'Collectibles & Fine Arts | Sure',
      description:
        'Get Collectibles and Fine Arts insurance through Sure to protect your treasures.',
      url: 'https://www.sureapp.com/collectibles',
      fallback: true,
    });
    if (this.props.isLoggedIn) {
      this.props.getPoliciesForVertical(VERTICALS.collectibles.code);
    }
    if (compact(this.props.location.pathname.split('/')).length >= 3) {
      this.setState({
        isPolicyFlow: true,
      });
    } else {
      this.setState({
        isPolicyFlow: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if (compact(this.props.location.pathname.split('/')).length >= 3) {
        this.setState({
          isPolicyFlow: true,
        });
      } else {
        this.setState({
          isPolicyFlow: false,
        });
      }
    }
  }

  get isCollectiblesMulticheckoutEnabled() {
    return (
      process.env.REACT_APP_IS_COLLECTIBLES_MULTI_CHECKOUT_ENABLED ||
      this.props.isHagerty
    );
  }

  get renderFooter() {
    if (!this.props.isEmbed && this.state.isPolicyFlow) {
      if (this.props.location.pathname.match(/\/collectibles\/.*\/.+/)) {
        return <Footer activeLink={this.props.location.pathname} />;
      } else {
        return <Footer activeLink={this.props.location.pathname} />;
      }
    } else {
      return null;
    }
  }

  get renderWrapper() {
    if (compact(this.props.location.pathname.split('/')).length <= 2) {
      return (
        <Fragment>
          {React.cloneElement(this.props.children, {
            ...omit(this.props, 'children'),
            isCollectiblesMulticheckoutEnabled: this
              .isCollectiblesMulticheckoutEnabled,
          })}
          {!this.props.isEmbed &&
            without(
              compact(this.props.location.pathname.split('/')),
              'payment',
              'confirmation'
            ).length > 2 && (
              <TrustSymbols
                activeLink={this.props.location.pathname}
                protectionList={protectionList}
                verticalName={verticalName}
                disclaimer={this.props.disclaimer}
              />
            )}
        </Fragment>
      );
    } else {
      return (
        <div className="CollectiblesContainer-wrapper">
          {React.cloneElement(this.props.children, {
            ...omit(this.props, 'children'),
            isCollectiblesMulticheckoutEnabled: this
              .isCollectiblesMulticheckoutEnabled,
          })}
          {!this.props.isEmbed &&
            without(
              compact(this.props.location.pathname.split('/')),
              'payment',
              'confirmation'
            ).length > 2 && (
              <TrustSymbols
                activeLink={this.props.location.pathname}
                protectionList={protectionList}
                verticalName={verticalName}
                disclaimer={this.props.disclaimer}
              />
            )}
        </div>
      );
    }
  }

  render() {
    const {
      isEmbed,
      isLoggedIn,
      userFullName,
      isMenuOpen,
      location,
      showGlobalModal,
      disclaimer,
      hideMenu,
      showMenu,
      toast,
      hideToast,
    } = this.props;
    return (
      <Fragment>
        <div className="CollectiblesContainer">
          {!isEmbed && this.state.isPolicyFlow && (
            <TopNavBar
              isLoggedIn={isLoggedIn}
              userFullName={userFullName}
              isMenuOpen={isMenuOpen}
              isFixed
              activeLink={location.pathname}
              showGlobalModal={showGlobalModal}
              verticalName={verticalName}
              protectionList={protectionList}
              disclaimer={disclaimer}
              onHideMenu={hideMenu}
              onShowMenu={showMenu}
            />
          )}
          {this.props.notificationMessage && (
            <NotificationBar
              message={this.props.notificationMessage}
              onDismiss={this.props.hideCollectiblesNotificationBar}
              sureStyle="info"
              isFullWidth={!this.state.isPolicyFlow}
              className="NotificationBar--collectibles"
            />
          )}
          {this.renderWrapper}
          {toast && (
            <Toast
              message={toast.message}
              sureStyle={toast.style}
              onDismiss={hideToast}
            />
          )}
        </div>
        {this.renderFooter}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: !!state.authToken,
  isMenuOpen: state.isMenuOpen,
  toast: state.toast,
  account: state.account,
  isEmbed: state.isEmbed,
  collectiblesPolicies: filter(state.policiesById, {
    vertical_code: VERTICALS.collectibles.code,
  }),
  userFullName: `${state.account.firstName} ${state.account.lastName}`,
  fullName: compact([
    state.collectiblesResponses.owner_first_name,
    state.collectiblesResponses.owner_middle_name,
    state.collectiblesResponses.owner_last_name,
    state.collectiblesResponses.owner_suffix,
  ]).join(' '),
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      hideMenu,
      hideToast,
      goBack,
      showMenu,
      getPoliciesForVertical,
      navTo: push,
    },
    dispatch
  ),
});

const enhance = compose(
  withRouter,
  withGlobals({
    analyticsPrefix: 'Collectibles',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withSubapp(
    { ...collectiblesApi, ...sharedApi },
    {
      blacklistCategories: ['jewelry'],
    }
  )
);

export default enhance(CollectiblesContainer);
